<template>
  <div class="c-plan g-container">
    <Breadcrumb class="m-bread">
      <BreadcrumbItem> <Icon type="ios-home-outline"></Icon> 选择投放账号 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="logo-buffer"></Icon> 设置计划 </BreadcrumbItem>
    </Breadcrumb>

    <!-- 滚动区域 -->
    <div class="module-content" ref="container">
      <moduler v-for="item in subModules" :key="item.id" :title="item.name" :name="item.href">
        <!-- 基础信息 -->
        <template v-if="item.href === 'plan_basic'">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">计划组名称</span>
            </Col>
            <Col span="18">
              <input-len
                ref="planinput"
                v-model="plan.plan_name"
                placeholder="最大90个字符，1个中文等于2个字符"
                width="480"
                :max="90"
                :dyn-pos="dynpos"
                @on-del-trend="validTrend"
                @on-focus="focusPlan"
                @on-blur="blurPlan"
                @change="validTrend"
              />
              <span style="margin-left: 12px" v-if="check">
                <Icon type="ios-loading" color="#5cadff" size="18" v-if="check === 'loading'" />
                <Icon type="md-checkmark" color="#19be6b" size="18" v-if="check === 'success'" />
                <Icon type="md-close" color="#ed4014" size="18" v-if="check === 'error'" />
                <span v-if="check === 'success'">标题可用</span>
                <span v-if="check === 'error'">此标题已被占用，请换一个！</span>
              </span>
              <dd class="dynamic-error g-error-text" v-html="dynErr"></dd>
              <ul class="m-dynamic">
                <span>插入动态名称:</span>
                <li v-for="(word, i) in dynwords" :key="i">
                  <a href="javascript:;" @click.stop="appendTrend(word)">+{{ word }}</a>
                </li>
              </ul>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">游戏平台</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.ch_platform_id" type="button" @on-change="platformChange">
                <Radio :label="1" :disabled="plan.landing_type === 'APP' || editState">Android</Radio>
                <Radio :label="2" :disabled="plan.landing_type === 'APP' || editState">iOS</Radio>
                <Radio :label="3" v-if="plan.landing_type === 'LINK'">小程序</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">投放游戏</span>
            </Col>
            <Col span="12">
              <auto-complete
                :data="platformGameData"
                v-model="plan.game_id"
                placeholder="请选择推广游戏"
                :width="358"
                :disabled="editState"
                @on-select="handleGame"
              ></auto-complete>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">是否代投</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.agent" type="button" @on-change="changeAgent">
                <Radio label="NOAGENT" :disabled="editState">非代投</Radio>
                <Radio label="AGENT" :disabled="editState">代投</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row v-if="plan.agent === 'AGENT'" class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">代投账号</span>
            </Col>
            <Col span="12">
              <auto-complete
                :data="agentData"
                v-model="plan.proxy_account_id"
                placeholder="请选择代投账号"
                :disabled="editState"
                @on-select="handleAgent"
              ></auto-complete>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">投放方式</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.landing_type" type="button">
                <Radio label="APP" disabled>APP应用</Radio>
                <Radio label="LINK" disabled>落地页</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row v-if="plan.landing_type === 'LINK'" class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">落地页地址</span>
            </Col>
            <Col span="12">
              <Input
                v-model="plan.page_addr"
                readonly
                placeholder="选择内部落地页"
                style="width: 480px; margin-right: 6px"
                :disabled="editState"
              />
              <Button type="primary" @click="linkModel = true" :disabled="editState" style="margin-right: 0">选择落地页</Button>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">计划管家</span>
            </Col>
            <Col span="12">
              <select-butler :data="plan.managePlan" :disabled="editState" @on-clear="plan.managePlan = []" @on-select="appendButler" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">智能自动化</span>
            </Col>
            <Col span="12">
              <select-monitor :data="plan.monitorPlan" :media="media" :open-id="opId" @on-delete="delMonitor" @on-select="appendMonitor" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">回调开关</span>
            </Col>
            <Col span="12" class="col-flex">
              <i-Switch v-model="plan.callback_switch" :disabled="editState || !isAndroid" :true-value="1" :false-value="0" />
              <span v-if="!isAndroid" style="color: #ff0000; margin-left: 1em">IOS、小程序请务必选择需要的回调类型</span>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="plan.callback_switch">
            <Col span="3" class="col-item">
              <span class="item-field">回调类型</span>
            </Col>
            <Col span="12" class="col-flex">
              <CheckboxGroup v-model="plan.callback_settings">
                <Checkbox label="callbackTypeActive" disabled>激活</Checkbox>
                <Checkbox label="callbackTypeRegist">注册</Checkbox>
                <Checkbox label="callbackTypeRecharge">付费</Checkbox>
                <Checkbox label="callbackTypeMoney">订单金额</Checkbox>
              </CheckboxGroup>
            </Col>
          </Row>
        </template>

        <!-- 流量及投放方式 -->
        <template v-if="item.href === 'plan_client'">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">流量范围</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.union" type="button">
                <Radio label="NONE">默认</Radio>
                <Radio label="CUSTOM" disabled>百青藤</Radio>
              </RadioGroup>
            </Col>
          </Row>
        </template>

        <!-- 定向 -->
        <div v-if="item.href === 'plan_target'" style="position: relative">
          <!-- 选择定向弹窗 -->
          <select-targeter
            ref="selectTarget"
            :data="targetPlan"
            :adder="targetPlan.length < 50"
            :media="media"
            :platform="plan.ch_platform_id"
            :open-id="opId"
            :orign-data="DATA"
            @on-current="setTargeter"
            @on-delete="delTargeter"
            @on-select="appendTargeter"
          />

          <targeting
            ref="targeting"
            :show="show"
            :media="media"
            :account="account"
            :accounts="accounts"
            :target="curTarget"
            :target-name="curName"
            :land-type="plan.landing_type"
            :is-union="isUnion"
            :is-android="isAndroid"
            :is-link="isLink"
            @on-name="targetNameChange"
            @on-target-change="radioChange($event)"
          />
        </div>

        <!-- 其他设置 -->
        <template v-if="item.href === 'plan_other'">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">自动优化账号</span>
            </Col>
            <Col span="12">
              <Mixcheck v-model="plan.autoOpt.autoOptStrategies">
                <check-item :label="1" allow>兴趣定向</check-item>
                <check-item :label="2" allow>意图词定向</check-item>
                <check-item :label="4" allow>创意</check-item>
              </Mixcheck>
              {{ plan.autoOpt }}
            </Col>
          </Row>
        </template>

        <!-- 预算与出价 -->
        <template v-if="item.href === 'plan_price'">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">优化目标</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.bidtype" type="button">
                <Radio :label="3" :disabled="editState">转化</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">转化名称</span>
            </Col>
            <Col span="12">
              <TransFeed
                v-if="isLink && isMiniProgram"
                v-model="plan.appTransIdByAccount"
                :trans-list="miniProgramTransList"
                :accounts="accounts"
                @account-change="getConvertByAccount"
              ></TransFeed>

              <Input v-else readonly placeholder="系统自动创建转化名称，无需填写" style="width: 480px" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">出价模式</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.ocpcLevel" type="button">
                <Radio :label="2" :disabled="editState">转化出价</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <!-- 小程序不显示、推广落地页放到第四步配置 -->
          <Row class="row-item" :gutter="12" v-if="plan.landing_type === 'LINK' && !isMiniProgram">
            <Col span="3" class="col-item">
              <span class="item-field">推广落地页</span>
            </Col>
            <Col span="12">
              <input-len
                ref="lpurl"
                v-model="plan.lpUrl"
                placeholder="手动填写落地页或者使用系统内部生成落地页"
                :disabled="plan.innerUrl"
                :max="1024"
                :width="480"
              />
              <div class="col-check-box">
                <Checkbox v-model="plan.innerUrl" @on-change="focuslpUrl"> 使用系统内部落地页 </Checkbox>
              </div>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">转化类型</span>
            </Col>
            <Col span="12">
              <Select v-model="plan.transType" style="width: 180px" @on-change="changeTransType">
                <!-- transType 文档 https://dev2.baidu.com/content?sceneType=0&pageId=100052&nodeId=73&subhead= -->
                <template v-if="plan.ch_platform_id === 3">
                  <Option :value="49" :disabled="editState">登录</Option>
                  <Option :value="26" :disabled="editState">付费</Option>
                </template>

                <template v-else>
                  <Option :value="4" :disabled="editState">激活</Option>
                  <Option :value="26" :disabled="editState">付费</Option>
                </template>
              </Select>

              <span v-if="plan.transType === 26" style="margin-left: 10px">
                <!-- 开启深度转化出价时，取消勾选且禁用 -->
                <Checkbox v-model="plan.transTypeAttribute" :disabled="plan.deep_bid_mode">优化付费次数</Checkbox>
                <Tooltip placement="top" content="按照付费次数优化不允许叠加选择ROI优化"> <Icon type="md-information-circle" /> </Tooltip>
              </span>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">目标转化出价</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.bid_range" type="button" @on-change="changeBidRange">
                <Radio :label="0">固定金额</Radio>
                <Radio :label="1">随机金额</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="plan.bid_range">
            <Col span="3" class="col-item">&nbsp;</Col>
            <Col span="12">
              <input-range v-model="plan.bid_num_range" :precision="2" :min="0.3" :max="99999.99" placeholder="金额" />
              <span> 元/转化</span>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-else>
            <Col span="3" class="col-item">&nbsp;</Col>
            <Col span="12">
              <input-number-plus
                v-model="plan.ocpcBid"
                :max="5"
                :min="0.3"
                :step="0.1"
                :precision="2"
                :width="100"
                placeholder="输入转化价格"
              />
              <span> 元/转化</span>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">深度转化出价</span>
            </Col>
            <Col span="12" class="col-flex">
              <i-Switch v-model="plan.deep_bid_mode" @on-change="changDeepBid" />
            </Col>
          </Row>
          <!-- 付费 -->
          <template v-if="plan.deep_bid_mode && plan.transType === 26">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">深度优化方式</span>
              </Col>
              <Col span="12" class="col-flex">
                <RadioGroup v-model="plan.useRoi" type="button">
                  <Radio label="useRoi" :disabled="editState">优化ROI</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">ROI系数</span>
              </Col>
              <Col span="12">
                <input-number-plus
                  v-model="plan.roiRatio"
                  :max="3"
                  :min="0.01"
                  :step="0.1"
                  :precision="2"
                  :width="198"
                  placeholder="请输入系数，范围: 0.01 ~ 100 "
                />
              </Col>
            </Row>
          </template>
          <template v-else-if="plan.deep_bid_mode">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">深度优化方式</span>
              </Col>
              <Col span="12" class="col-flex">
                <RadioGroup v-model="plan.optimizeDeepTrans" type="button">
                  <Radio label="optimizeDeepTrans" :disabled="editState">优化深度转化</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">深度转化目标</span>
              </Col>
              <Col span="12">
                <Select v-model="plan.deepTransType" style="width: 180px">
                  <Option :value="26" :disabled="editState">付费</Option>
                </Select>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">深度转化目标出价</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="plan.deep_bid_range" type="button" @on-change="changeDeepCpabidRange">
                  <Radio :label="0">固定金额</Radio>
                  <Radio :label="1">随机金额</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-if="plan.deep_bid_range">
              <Col span="3" class="col-item">&nbsp;</Col>
              <Col span="12">
                <input-range v-model="plan.deep_deepbid_num_range" :precision="2" :min="0.4" :max="99999.99" placeholder="金额" />
                <span> 元</span>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-else>
              <Col span="3" class="col-item">&nbsp;</Col>
              <Col span="12">
                <input-number-plus
                  v-model="plan.deepOcpcBid"
                  :max="5"
                  :min="0.4"
                  :step="0.1"
                  :precision="2"
                  :width="100"
                  placeholder="输入深度价格"
                />
                <span> 元</span>
              </Col>
            </Row>
          </template>
        </template>
      </moduler>
    </div>

    <!-- 落地页弹框 -->
    <landpage v-model="linkModel" :default-game-id="plan.game_id" @on-select="selectLinkLandPage"></landpage>

    <converter
      v-model="convertModel"
      :accounts="accounts"
      :platform="plan.ch_platform_id"
      :game-id="plan.game_id"
      :package="plan.package"
      :check-url="plan.game_address"
      @on-complete="jump"
    />

    <!-- 提交按钮 -->
    <affix target="c-create-scroll" :offsetBottom="0">
      <div class="c-plan-submit">
        <Row :gutter="12">
          <Col span="12">
            <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
          </Col>
          <Col span="12" class="c-btns-submit">
            <Button type="primary" :loading="saving" disabled>
              <span v-if="!saving">上一步</span>
              <span v-else>提交中...</span>
            </Button>
            <Button type="primary" :loading="loading" @click.stop="submitToNext">
              <span v-if="!loading">下一步</span>
              <span v-else>提交中...</span>
            </Button>
          </Col>
        </Row>
      </div>
    </affix>
  </div>
</template>
<script>
import opts from './plan_opts.js'
export default opts
</script>
<style lang="scss" scoped>
.c-plan {
  height: inherit;

  .m-bread {
    line-height: 20px;
    margin-bottom: 12px;
  }

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 96px);
  }

  .c-plan-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    position: relative;
    z-index: 98;

    .c-btns-submit {
      text-align: right;

      button {
        margin-left: 8px !important;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  .col-check-box {
    display: inline-block;
    margin-left: 12px;
  }

  .col-min-width {
    min-width: 680px;
  }

  .col-flex {
    min-height: 32px;
    display: flex;
    align-items: center;
  }

  ::v-deep .row-item {
    align-items: flex-start;

    span.item-field {
      height: 32px;
      line-height: 32px;
    }
  }

  .dynamic-error {
    margin: 0;
  }

  .m-dynamic {
    padding-top: 10px;
    margin: 0;

    li {
      display: inline-block;
      margin-left: 12px;
    }
  }
}
</style>
